import PropTypes from 'prop-types';
import React from 'react';

import useSiteMetadata from '../../hooks/use_site_metadata';
import useTranslation from '../../hooks/use_translation';
import ProductGroupList from './product-group-list';

const ProductList = ({ group_id }) => {
	const siteMetadata = useSiteMetadata();

	return (
		<ProductGroupList
			activeId={group_id}
			exclude_groups={[
				...siteMetadata.config.ignore_allergy_groups,
				...siteMetadata.config.business_tests_groups,
			]}
		/>
	);
};

const TestGroups = ({ activeAccordion, group_id, ...props }) => {
	const { t } = useTranslation('component_test_groups');

	return (
		<>
			<div {...props} className="accordion accordion-flush" id="tests-groups">
				<div className="accordion-item">
					<h4 className="accordion-header" id="product-groups">
						<button
							aria-controls="product-groups-list"
							aria-expanded="false"
							className="accordion-button collapsed sm fw-700"
							data-bs-target="#product-groups-list"
							data-bs-toggle="collapse"
							type="button"
						>
							{t('t1')}
						</button>
					</h4>
					<div
						aria-labelledby="test-groups"
						className={`accordion-collapse collapse ${activeAccordion === 'category' ? 'show' : ''}`}
						id="product-groups-list"
					>
						<div className="accordion-body accordion-body-sm bg-gray-100 px-3 py-2">
							<ProductList group_id={group_id} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

ProductList.propTypes = {
	group_id: PropTypes.number,
};

TestGroups.propTypes = {
	activeAccordion: PropTypes.string,
	group_id: PropTypes.number,
};

export default TestGroups;
